<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-toolbar
          color="primary"
          class="text-h6 elevation-0"
          dark
        >
          Selecione a data de vencimento
        </v-toolbar>
        <v-card-text class="pa-10">
          <v-menu
            v-model="vencimento.menu"
            :close-on-content-click="false"
            max-width="290"
          >
            <template #activator="{ on }">
              <v-text-field
                :value="dateVencimento"
                label="Data de Vencimento"
                clearable
                outlined
                readonly
                v-on="on"
                @click:clear="vencimento.date = null"
              />
            </template>
            <v-date-picker
              v-model="vencimento.date"
              :min="dateMin"
              @change="vencimento.menu = false"
            />
          </v-menu>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-btn
            text
            @click="closeDialog"
          >
            Cancelar
          </v-btn>
          <v-spacer />
          <v-btn
            :disabled="!dateVencimento"
            text
            :loading="isLoadingBtn"
            @click="baixarDae"
          >
            GERAR DAE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SaneamentoService from "@/services/gessan/saneamento.service";
import moment from "moment";

export default {
  name: "DialogBaixarDae",
  props: {
    nossoNumero: { type: String, required: true },
    cpfCnpj: { type: String, default: "" },
    dataVencimento: { type: String, default: "" },
    isGrupo: { type: Boolean, default: false },
  },
  data() {
    return {
      dialog: false,
      vencimento: {
        date: null,
        menu: false,
      },
      isLoadingBtn: false,
    };
  },
  computed: {
    dateVencimento() {
      return this.vencimento.date
        ? moment(this.vencimento.date).format("DD/MM/YYYY")
        : "";
    },
    dateMin() {
      return moment().format("YYYY-MM-DD");
    },
  },
  mounted() {
    this.dialog = true;
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.$emit("close");
    },
    baixarDae() {
      this.isLoadingBtn = true;
      const checkDate = this.vencimento.date || this.dataVencimento;
      const formatDate = moment(checkDate).format("DD/MM/YYYY");
      SaneamentoService.downloadDAEVencido(
        this.nossoNumero,
        formatDate,
        this.cpfCnpj,
        this.isGrupo
      ).subscribe(
        (res) => {
          // const file = new Blob([res], { type: "application/pdf" });
          // const fileURL = URL.createObjectURL(file);
          // window.open(fileURL);
          // this.isLoadingBtn = false;
          // this.vencimento = { date: null, menu: false };
          const { dae } = res?.result

          this.$emit("gerarDae", dae);
          this.closeDialog();
        },
        () => {
          this.isLoadingBtn = false;
          this.closeDialog();
          this.$emit("error", "Não foi possível processar a requisição");
        }
      );
    },
  },
};
</script>
